var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 14,
    viewBox: "0 0 38 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7453_12784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4669 13.3124H13.3887L15.314 0.728027H18.3921L16.4669 13.3124Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6256 1.03577C27.0184 0.781139 26.0554 0.5 24.8646 0.5C21.8247 0.5 19.684 2.21352 19.6709 4.66335C19.6457 6.47082 21.2036 7.47474 22.3688 8.0774C23.5597 8.69324 23.9645 9.0952 23.9645 9.64413C23.9524 10.4872 23.0022 10.8758 22.1159 10.8758C20.8869 10.8758 20.2284 10.6754 19.2277 10.2064L18.8224 10.0053L18.3916 12.8303C19.1136 13.1779 20.4437 13.4865 21.8247 13.5C25.0546 13.5 27.1574 11.813 27.1823 9.20232C27.1946 7.76975 26.372 6.67207 24.5985 5.77509C23.5218 5.19929 22.8625 4.81103 22.8625 4.22189C22.8751 3.6863 23.4201 3.13772 24.6355 3.13772C25.6362 3.11085 26.3715 3.36513 26.9285 3.61957L27.2069 3.7532L27.6256 1.03577Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7167 8.85419C31.9702 8.13123 32.9457 5.33319 32.9457 5.33319C32.9329 5.36006 33.1987 4.59689 33.3507 4.12838L33.5658 5.21273C33.5658 5.21273 34.1487 8.22501 34.2753 8.85419C33.7942 8.85419 32.3247 8.85419 31.7167 8.85419ZM35.5164 0.728027H33.1354C32.4011 0.728027 31.8433 0.95543 31.5265 1.77216L26.9541 13.3122H30.184C30.184 13.3122 30.7158 11.759 30.8301 11.4245C31.1844 11.4245 34.3265 11.4245 34.7823 11.4245C34.8707 11.8663 35.1496 13.3122 35.1496 13.3122H37.9998L35.5164 0.728027Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8177 0.728027L7.80311 9.30935L7.47368 7.56895C6.91634 5.56077 5.16839 3.37892 3.21777 2.29404L5.97907 13.299H9.23426L14.0728 0.728027H10.8177Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0033 0.728027H0.0506674L0 0.982298C3.86336 2.0266 6.42199 4.54386 7.47322 7.56949L6.39657 1.78586C6.21932 0.98212 5.6746 0.75454 5.0033 0.728027Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7453_12784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.ef8ca0e4dabb54a3df34fe391c9a21c7.svg";
export { ForwardRef as ReactComponent };